<button
  *ngIf="isMobile"
  tuiIconButton
  type="button"
  appearance="icon"
  iconStart="@tui.circle-plus"
  size="s"
  aria-label="Разместить"
  class="add-button"
  (click)="buttonClick.emit()"
></button>

<button *ngIf="isDesktop" tuiButton type="button" size="l" (click)="buttonClick.emit()">
  {{ title ?? ('components.loyaltyProgram.buttons.createProduct' | translate) }}
</button>
